import kfetch from '@kareo/kfetch';

class PracticeUsers {
  constructor() {
    this.instance = null;
  }

  async getAllPracticeUsers(options = {}) {
    if (!this.practiceUsers) {
      let response = await kfetch('/common-ui/api/User/getAllUsers', options);
      this.practiceUsers = response;
    }

    return this.practiceUsers;
  }

  static get() {
    if (!this.instance) {
      this.instance = new PracticeUsers();
    }

    return this.instance;
  }
}

// Export a single instance of the FeatureToggles class
const practiceUsers = PracticeUsers.get();
export default practiceUsers;
